import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { SessionContext, AppContext } from 'contexts'
import { getStatusColor } from 'constants/status'
import { Box } from 'reflexbox'
import { initialState, fields, labels, handlers } from 'models/checkinPage'
import {
  Center,
  Grid,
  Button,
  Link,
  Section,
  StatusChip,
  Toolbar,
} from 'components/core'
import Page from 'components/Page'
import { MdArrowBack, MdEdit, MdPrint } from 'react-icons/md'
import { renderDeleteLink } from 'utilities/app'
import { IoIosBarcode } from 'react-icons/io'
import PartScanModal from './PartScanModal'

export default ({ match, profile }) => {
  const { id } = match.params
  const history = useHistory()
  const { formatMessage: message } = useIntl()
  const session = useContext(SessionContext)
  const app = useContext(AppContext)
  const [state, setState] = useState(initialState())
  const [open, setOpen] = useState(false)

  const readonly = profile === 'view'
  const form = readonly
    ? labels({ state, setState })
    : fields({ app, session, state, setState, profile })
  const handler = handlers({
    app,
    session,
    state,
    setState,
    message,
    history,
    profile,
    id,
  })

  useEffect(() => {
    handler.handleLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, profile])

  return (
    <>
      <Page
        profile={profile}
        navId="checkinList"
        title={`checkin.title.${profile}`}
        titleExtra={
          <StatusChip
            show={readonly}
            ml={2}
            label={`status.${state.status}`}
            color={getStatusColor(state.status)}
            bg="light.1"
          />
        }
        action={
          <Center>
            <Link
              variant="link"
              icon={<MdArrowBack />}
              text="btn.back"
              href="/checkin"
            />
            <Link
              ml={3}
              show={readonly}
              variant="link"
              icon={<MdPrint />}
              onClick={handler.handlePrint}
            />
            {renderDeleteLink({
              module: 'checkin',
              session,
              readonly,
              status: state.status,
              onSubmit: handler.handleDelete,
            })}
            <Link
              ml={3}
              show={readonly}
              disabled={state.status === 'INACTIVE'}
              variant="link"
              icon={<MdEdit />}
              href={`/checkin/${id}/edit`}
            />
            <Button
              ml={3}
              show={!readonly}
              variant="primary"
              text="btn.save"
              onClick={handler.handleSubmit}
            />
          </Center>
        }
        showFooterAction
        as="form"
        audit={{
          createdBy: state.createdBy,
          createdAt: state.createdAt,
          updatedBy: state.updatedBy,
          updatedAt: state.updatedAt,
        }}
      >
        <Grid cols={['1fr', '1fr 3fr']} gap={3}>
          <Box>
            <Section title="checkin.section.basic">
              {form.id}
              {form.transDate}
              {form.techId}
              {form.warehouseId}
              {form.memo}
            </Section>
          </Box>
          <Box mt={[4, 0]}>
            <Section title="checkin.section.part">
              <Toolbar show={!readonly}>
                <Button
                  variant="default"
                  icon={<IoIosBarcode />}
                  text="part.btn.scan"
                  onClick={() => setOpen(true)}
                />
              </Toolbar>
              {form.ticketItems}
            </Section>
          </Box>
        </Grid>
      </Page>
      <PartScanModal
        open={open}
        data={{ parts: state.parts, ticketItems: state.ticketItems }}
        action={{
          handleScan: handler.handleScan,
          handleClose: () => setOpen(false),
        }}
      />
    </>
  )
}
